import { useGetMany } from 'react-admin';
import { Merchant } from 'types/embedded/merchant';
import { MerchantAccess } from 'types/embedded/merchantAccess';

type MerchantAccessWithMerchantId = Omit<MerchantAccess, 'merchant'> & {
  merchant: string;
};

export function useGetUsersMerchants(merchantAccessesIds?: string[]) {
  const { data: merchantAccesses } = useGetMany<MerchantAccessWithMerchantId>(
    'merchant_accesses',
    {
      ids: merchantAccessesIds,
    },
    {
      enabled: !!merchantAccessesIds?.length,
    },
  );

  const { data: merchants } = useGetMany<Merchant>(
    'merchants',
    {
      ids: merchantAccesses?.map((merchantAccess) => merchantAccess?.merchant),
    },
    {
      enabled: !!merchantAccesses?.length,
    },
  );

  return { merchants };
}
